import { Component, Prop, Vue } from "vue-facing-decorator";
import Button from "../components/button.vue";
import Img from "../components/image.vue";
import type { MessageContentSettings, MessageStructureComponent } from "../types";
import type { InlineClickAction } from "../types/inline_click_action";
import { InlineActionHandler } from "../helpers/inline-actions/inline_action_handler";
import { Util } from "../util";

declare var marked;
@Component({
	components: { Button, Img },
})
export default class Card extends Vue {
	//#region Component Props

	@Prop() components?: MessageStructureComponent[];
	@Prop() structureIndex?: number;
	@Prop() msgIndex?: number;
	@Prop() structure?: Object;
	@Prop() structureSettings?: any;
	@Prop() messageContentsettings?: MessageContentSettings;
	@Prop({
		type: Object,
		default() {
			return {};
		},
	})
	inlineClickActions?: Record<string, InlineClickAction>;
	inlineActionHandler!: InlineActionHandler;

	@Prop({ type: [String, Number] })
  messageId!: string | number;
	//#endregion

	//#region Computed Properties

	get prefixClassName() {
		return this.$store.state.prefixClassName || "";
	}

	//#endregion

	marked(value) {
		return marked(value);
	}

	//#region Lifecycle Hooks

	/**
	 * Lifecycle hook: Runs after the component has been mounted to the DOM.
	 */
	mounted() {
		//@ts-ignore
		// $nextTick is used to ensure that the DOM is fully rendered before executing the function
		this.$nextTick(() => {
			this.listenEvents();
		});
	}

	/**
	 * Lifecycle hook: Runs before the component is destroyed.
	 */
	beforeDestroy() {
		this.removeEvents();
	}

	/**
	 * Gets the HTML container element for the bubble.
	 */
	get container() {
		//@ts-ignore
		return this.$refs.containerRef as HTMLElement;
	}

	/**
	 * Adds event listeners to the bubble container on component mount.
	 */
	listenEvents() {
		try {
			this.inlineActionHandler = new InlineActionHandler(this.components, this.container, this.inlineClickActions, this.messageId);
			if (!this.inlineActionHandler) return; // skip if not initialized
			if (!this.inlineActionHandler.bind || typeof this.inlineActionHandler.bind !== "function") return;
			// Bind the click event handler to the container element
			this.inlineActionHandler.bind();
		} catch (ex) {
			console.log("[card.ts] An error has occurred \n-> Inside listenEvents -> Error: ", ex);
		}
	}

	/**
	 * Removes event listeners from the bubble container on component destruction.
	 */
	removeEvents() {
		try {
			if (!this.inlineActionHandler) return; // skip if not initialized
			if (!this.inlineActionHandler.unbind || typeof this.inlineActionHandler.unbind !== "function") return;
			// Unbind the click event handler from the container element
			this.inlineActionHandler.unbind();
		} catch (ex) {
			console.log("[card.ts] An error has occurred \n-> Inside removeEvents -> Error: ", ex);
		}
	}

	formatMessageContent(messageContent:string){
		return Util.formatTextWithAccessibleEmojis(messageContent)
	}
	//#endregion
}
